import { USER_MESSAGE_ID_KEY } from '@/components/message/user-message-group';
import {
  MENTION_CONTAINER,
  MENTION_TAG_KEY,
} from '@/components/ui/markdown/components/mention-tag';
import { useEffect } from 'react';

const escapeRegExp = (value: string) =>
  value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

const getMentionCopyPatterns = (fullName: string): RegExp[] => {
  const escapedName = escapeRegExp(fullName);
  return [
    // Mac: 前导换行 + icon alt + 换行 + 名称 + 尾部换行（最完整格式）
    new RegExp(`\\r?\\nicon\\r?\\n${escapedName}\\r?\\n`),
    // 优先匹配并移除 mention 后自动插入的换行
    new RegExp(`icon\\r?\\n${escapedName}\\r?\\n`),
    // Windows / 无icon: 前导换行 + 名称 + 尾部换行
    new RegExp(`\\r?\\n${escapedName}\\r?\\n`),
    // Mac: 前导换行 + icon alt + 换行 + 名称（末尾位置无尾部换行）
    new RegExp(`\\r?\\nicon\\r?\\n${escapedName}`),
    // 兼容历史复制行为
    new RegExp(`icon\\r?\\n${escapedName}`),
    new RegExp(`\\r?\\n${escapedName}`),
  ];
};

const handleCopy = (event: ClipboardEvent) => {
  try {
    event.preventDefault();
    const selection = window.getSelection();
    const originalText = selection?.toString() || '';
    const container = selection?.anchorNode?.parentElement
      ? selection.anchorNode.parentElement.closest(`[${USER_MESSAGE_ID_KEY}]`)
      : null;

    if (!container) {
      event.clipboardData?.setData('text/plain', originalText);
      return;
    }

    let transformedText = originalText;

    if (selection && selection.rangeCount > 0) {
      const range = selection.getRangeAt(0);
      const clonedContent = range.cloneContents();
      // 查找提及节点
      const mentionNodes = clonedContent.querySelectorAll(
        `[${MENTION_CONTAINER}]`,
      );
      mentionNodes.forEach((node) => {
        const fullName = node.getAttribute(MENTION_TAG_KEY);
        const copiedText = node.textContent?.trim();
        // 只有当复制的文本等于完整名称时才转换
        if (fullName && copiedText === fullName) {
          const patterns = getMentionCopyPatterns(fullName);

          for (const pattern of patterns) {
            if (pattern.test(transformedText)) {
              transformedText = transformedText.replace(
                pattern,
                `@${fullName}`,
              );
              break;
            }
          }
        } else {
          console.log('复制了不完整的name：' + copiedText);
        }
      });
    }

    event.clipboardData?.setData('text/plain', transformedText);
  } catch (error) {
    console.error('[handleCopy] 复制处理失败:', error);
  }
};

// 在用户消息被复制的时候，mention节点需要转换为@名称
export function useMessageCopy() {
  useEffect(() => {
    document.addEventListener('copy', handleCopy);

    return () => {
      document.removeEventListener('copy', handleCopy);
    };
  }, []);
}
